import { compose, find, prop } from 'ramda'

export const mergeRequestStates = (...states) => {
  const loading = states.some(prop('loading'))
  const error = compose(prop('error'), find(prop('error')))(states)
  const errors = compose(prop('errors'), find(prop('errors')))(states)
  return { loading, error: error || (errors && { message: errors.map(item => item.message).join(',\n') }) }
}
